// AI Chat Constants

// Tag names for matched plans
export const BROWSER_PLANS_TAG_OPEN = "<matched_plans>";
export const BROWSER_PLANS_TAG_CLOSE = "</matched_plans>";

// Extension-only actions (filtered out in web platform)
export const EXTENSION_ONLY_ACTIONS = [
  "create_connective_opportunity",
  "push_loan_data",
] as const;

// Error messages
export const BROWSER_PLANS_ERROR_MESSAGES = {
  PARSE_FAILED: "[draft-response] Failed to parse <matched_plans> JSON",
  TENANT_ID_REQUIRED: "Tenant ID is required",
  UNKNOWN_ERROR: "Unknown error",
  UNKNOWN_ACTION: (actionId: string) => `Unknown action: ${actionId}`,
} as const;

// Action status values
export const ACTION_STATUS = {
  PENDING: "pending",
  EXECUTING: "executing",
  COMPLETED: "completed",
  FAILED: "failed",
} as const;

// Action status colors
export const ACTION_STATUS_COLORS = {
  PENDING: "#9e9e9e",
  EXECUTING: "#1976d2",
  COMPLETED: "#4caf50",
  FAILED: "#f44336",
  TEXT_DEFAULT: "#616161",
} as const;

// UI Constants
export const UI_CONSTANTS = {
  ICON_SIZE: 16,
  FONT_SIZE_SMALL: "0.75rem",
  PADDING_MEDIUM: "1rem",
  TEXT_COLOR_DARK: "#212121",
  TEXT_COLOR_GRAY: "#757575",
  CONTENT_SEPARATOR: "\n\n",
} as const;

// API Endpoints
export const API_ENDPOINTS = {
  DRAFT_RESPONSE: "/chat-room/draft-response",
  DRAFT_RESPONSE_SSE: (tenantId: string) =>
    `/api/v1/jobs/draft-response/${tenantId}/status-sse`,
  FORMAT_RESPONSE: "/chat-room/format-response",
  LOOKUP_INTERNAL_KNOWLEDGE: "/chat-room/lookup-internal-knowledge",
  LOOKUP_INTERNAL_KNOWLEDGE_SSE: (tenantId: string) =>
    `/api/v1/jobs/lookup-internal-knowledge/${tenantId}/status-sse`,
  CREATE_CONVERSATION: "/conversation",
  LIST_CONVERSATIONS: "/conversation",
  GET_CONVERSATION_MESSAGES: (id: string) => `/conversation/${id}/messages`,
  DELETE_CONVERSATION: (id: string) => `/conversation/${id}`,
  UPDATE_CONVERSATION: (id: string) => `/conversation/${id}`,
} as const;

// Default values for API calls
export const API_DEFAULTS = {
  SEARCH_USER_LIMIT: 1,
  SEARCH_USER_PAGE: 1,
  SEARCH_LOAN_LIMIT: 10,
  SEARCH_LOAN_PAGE: 1,
  READ_LOAN_LIMIT: 1,
  READ_LOAN_PAGE: 1,
} as const;
